import { useState } from "react";

import AddCircleRounded from "@mui/icons-material/AddCircleRounded";
import { IconButton } from "@mui/material";

import { AmbulanzCreationDialog } from "@/common/components/ambulanzes/ambulanz-creation/AmbulanzCreationDialog";
import { useTranslation } from "@/translations";

export function AmbulanzCreationButton() {
  const { t } = useTranslation();
  const [showAmbulanzCreationDialog, setShowAmbulanzCreationDialog] = useState(false);

  return (
    <>
      <IconButton onClick={() => setShowAmbulanzCreationDialog(true)} aria-label={t("ambulanzes.create")}>
        <AddCircleRounded />
      </IconButton>
      {showAmbulanzCreationDialog && <AmbulanzCreationDialog onClose={() => setShowAmbulanzCreationDialog(false)} />}
    </>
  );
}
